import React, { useState } from 'react'
import Icon, { IconType } from '../../Icon'
import style from './VoteDetails.module.scss'
import { WebcastStatusForVotes, VoteDetails, VotesErrorType, VotesMode, VoteStatus } from './../types'
import Button, { ButtonType } from '../../Button'
import Confirmation from '../VotesError'
import componentStyles from '../VotesView/VotesView.module.scss'
import BackToListButton from '../BackToListButton'
import classNames from 'classnames'

const voteDetails: React.FC<VoteDetails> = ({
  id,
  question,
  options,
  setMode,
  webcastStatus,
  startVote,
  deleteVote = id => {},
  openVoteId,
  status
}) => {

  const [ confirmation, setConfirmation ]  = useState<'delete' | 'start' | undefined>(undefined)
  const btnText = 'Start poll'

  interface ConfirmationConfig  {
    error: VotesErrorType
    confirmHandler(): void
  }

  const startVoteHandler = () => {

    if( openVoteId && openVoteId !== id ){

      setConfirmation('start')
    }
    else{

      startVote(id)
    }
  }

  function confirmationConfig(): ConfirmationConfig {
    const config = {
      "delete": {
        error: VotesErrorType.DELETE_CONFIRMATION,
        confirmHandler: () => deleteVote(id)
      },
      "start": {
        error: VotesErrorType.START_NEW_POLL,
        confirmHandler: () => startVote(id)
      }
    }

    return config[confirmation!]
  }

  return  <>
  {confirmation ?
    <Confirmation
      error={confirmationConfig().error}
      confirmHandler={confirmationConfig().confirmHandler}
      cancelHandler={ () => {
        setConfirmation(undefined)
        setMode({ mode: VotesMode.DETAILS, selectedVoteId: id })
      } }/>
    :
      <div className={ style['polls-openquestion-container'] }
          data-bdd="polls-openquestion-container">
        <div className={style['qs_text']}>
          <div>Q:</div>
          <div className={ style['question'] }
            data-bdd='poll-question-text'
          >
            { question }
          </div>
        </div>
        <div className={ style['polls-options-sec'] }>
          <ul className={ style['polls-options-list'] }>
            {
              options && options.length && options.map((option, index) => {
                return (
                  <li key={ option.id ?? index }
                      data-bdd={`poll-answer-${index}`}
                      className={ style['polls-options'] }>
                    { option.value }
                  </li>
                )}
              )
            }
          </ul>
        </div>
        <div className={ style['openquestion-bottom-sec'] }>
          <BackToListButton setMode={setMode}/>

          <div className={ style['openquestion-options'] }>

            {
              status === VoteStatus.notstarted &&
              <>
              <Button
                color={IconType.colour.secondary}
                text={<Icon name={ IconType.iconName.trash }/>}
                onClick={ () => setConfirmation('delete') }
                dataBdd='delete-vote'
              />
              <Button
                color={IconType.colour.secondary}
                text={<Icon name={ IconType.iconName.pencil }/>}
                onClick={ () => setMode({ mode: VotesMode.EDIT, selectedVoteId: id }) }
                dataBdd='edit-vote'
              />
              </>
            }
            {
              webcastStatus === WebcastStatusForVotes.LIVE &&
              <Button
                dataBdd='start-vote-btn'
                text={ btnText }
                className={ componentStyles['start-button'] }
                type={ ButtonType.buttonType.button }
                onClick={ startVoteHandler }
              >
              </Button>
            }
          </div>
        </div>
      </div>}
</>

}

export default voteDetails
